import { Component } from "@angular/core";

@Component({
	selector: "ic-must-set-main-function-problem",
	templateUrl: "./must-set-main-function-problem.component.html",
	standalone: false,
})
export class MustSetMainFunctionProblemComponent {}
